<template>
    <v-navigation-drawer
        v-model="drawer"          
        width="400"
        app
        temporary
        right
        class="wost-drawer"
    >
        <div class="navigation-head">
            <span>{{ titleForm }}</span>                         
        </div>

        <div class="pl-3 pt-3 pr-3" style="height: 80vh;">                
            <template>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            ref="name"
                            v-model="colorForm.name" 
                            label="Nombre" 
                            outlined 
                            :rules="[() => !!colorForm.name || 'Es necesario ingresar un nombre']"
                            hide-details="auto"
                            required
                        ></v-text-field>
                    </v-col>
                </v-row>                  
            </template>                    
        </div>

        <div class="mt-3 pl-3 pt-3 pr-3">
            <template>
                <v-row>
                    <v-col cols="6">
                        <v-btn block height="40" dark color="red" @click="handleCancel">
                            <v-icon class="mr-1" size="16">far fa-times-circle</v-icon>
                            Cancelar
                        </v-btn>
                    </v-col>
                    <v-col cols="6">
                        <v-btn v-if="action == 'create'" dark color="success" block height="40" @click="handleStore">
                            <v-icon class="mr-1" size="16">far fa-save</v-icon>
                            Guardar
                        </v-btn>
                        <v-btn v-if="action == 'update'" dark color="success" block height="40" @click="handleUpdate">
                            <v-icon class="mr-1" size="16">far fa-save</v-icon>
                            Actualizar
                        </v-btn>
                    </v-col>
                </v-row>
            </template>               
            
        </div>

    </v-navigation-drawer>
</template>

<script>
import { mapActions} from 'vuex'

export default {
    name: 'CreateUpdate',
    data() {
        return {
            drawer: false,
            titleForm: null,
            action: null,
            colorForm: {
                id: null,
                name: null
            }
        }
    },
    methods: {
        ...mapActions('colors', [
            'store',
            'update'
        ]),
        async showForm(title, action, color = null) {
            await this.clearData();
            this.titleForm = title
            this.action = action
            if (color) {
                this.setColor(color)
            }
            this.drawer = !this.drawer
        },
        clearData() {
            this.titleForm = null
            this.action = null
            this.colorForm.id = null
            this.colorForm.name = null
            this.clearErrors();
        },
        setColor(color) {
            this.colorForm.id = color.id
            this.colorForm.name = color.name
        },
        closeForm() {
            this.clearData()
            this.drawer = false
        },
        handleCancel() {
            this.closeForm()
        },
        async handleStore() {
            if (!this.existErrors()) {
                await this.store(this.colorForm)
                this.closeForm()
            }            
        },
        async handleUpdate() {
            if (!this.existErrors()) {
                await this.update(this.colorForm)
                this.closeForm()
            }            
        },
        existErrors(){
            let hasErrors = false;

            Object.keys(this.colorForm).forEach(f => {                
                if (this.$refs[f]) {
                    if (!this.colorForm[f]) hasErrors = true
                    this.$refs[f].validate(true);
                }                
            });

            return hasErrors;
        },
        clearErrors() {
            Object.keys(this.colorForm).forEach(f => {
                if (this.$refs[f]) this.$refs[f].reset()                
            });
        },
    }
}
</script>

<style scoped>

</style>